import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { withStyles } from "@mui/styles";
import { getInfoArray } from "./infoHelper";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
const styles = (theme) => ({
  root: {
    padding: theme.spacing(1),
    flexGrow: 1,
  },
  table: {
    width: "100%",
    // border: "1px solid #f0f0f0",
    padding: 0,
    fontSize: 14,
  },
  title: {
    display: "inline-block",
    minWidth: 85,
  },
  title2: {
    display: "inline-block",
    minWidth: 125,
  },
  title3: {
    display: "inline-block",
    minWidth: 125,
  },
});

export class DailyStatusDriverInfo extends React.Component {
  render() {
    const { classes, handleClick } = this.props;
    const allItems = getInfoArray(this.props);
    return (
      <Table size="small" className={`${classes.table}`}>
        <TableBody>
          {allItems.map((item) => {
            return (
              <TableRow key={item.label}>
                <TableCell>
                  <span className={`${classes.title}`}>
                    {item.labelLink ? (
                      <span
                        style={{
                          color: "#009ce5",
                          cursor: "pointer",
                        }}
                        onClick={() => handleClick(item.label)}
                      >
                        {item.label}
                      </span>
                    ) : (
                      item.label
                    )}
                    :
                  </span>
                  <span
                    className={`${classes.border} ${classes.tdTwo}`}
                    style={{
                      textTransform:
                        item.label === "EMAIL" || item.label === "TRAILERS"
                          ? "none"
                          : "capitalize",
                    }}
                  >
                    {item.error && (
                      <WarningAmberIcon fontSize="small" color="error" />
                    )}
                    {item.value}
                  </span>
                </TableCell>

                <TableCell>
                  <span className={`${classes.title2}`}>
                    {item.labelMiddle}:
                  </span>
                  <span className={`${classes.content2}`}>
                    {item.valueMiddle}
                    {item.errorMiddle && (
                      <WarningAmberIcon fontSize="small" color="error" />
                    )}
                    {/*item.valueMiddleTwo ? (
                      <small>
                        <br />
                        {item.valueMiddleTwo}
                      </small>
                    ) : (
                      ""
                    )*/}
                  </span>
                </TableCell>
                <TableCell>
                  <span className={`${classes.title3}`}>
                    {item.labelRight}:
                  </span>
                  <span className={`${classes.content}`}>
                    {item.valueRight}
                  </span>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    );
  }
}

export default withStyles(styles)(DailyStatusDriverInfo);
